import cleanedFilename from '~/util/cleanedFilename';

export default {
  TOGGLE: `${cleanedFilename(__filename)}-toggle`,
};
